export default "__VITE_ASSET__2261b5a5__"